import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import { Stack, Typography } from '@mui/material';
import { FC } from 'react';

import { bold } from '@styles/fontWeights';

type BoostModalTitleProps = {
  title: string;
};

const BoostModalTitle: FC<BoostModalTitleProps> = ({ title }) => {
  return (
    <Stack direction="column" spacing={1}>
      <RocketLaunchOutlinedIcon
        sx={{
          fontSize: 60,
          color: 'primary.main',
          margin: 'auto !important',
        }}
      />
      <Typography
        variant="h1"
        component="p"
        color="secondary.light"
        p={2}
        fontWeight={bold}
      >
        {title}
      </Typography>
    </Stack>
  );
};

export default BoostModalTitle;
